import Vue from 'vue';
import VueRouter from 'vue-router';
import _ from 'lodash';
import lightup from './lightup';
import signup from './signup';
import login from './login';
import meitavDash from './meitav-dash';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.redirected)) {
      throw err;
    }
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.redirected)) {
      throw err;
    }
  });
};

Vue.use(VueRouter);

const routes = [
  signup,
  login,
  lightup,
  meitavDash,
  {
    path: '*',
    redirect: { name: 'AuthenticatedViews' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (_.isEmpty(to.query) && !_.isEmpty(from.query) && !to.fullPath.startsWith('/meitav/open-fund')) {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
